/**
 * Dr. Mani's Magic Quiz — interstitial screens (transition + pre-reveal build-up).
 * Inserted between Q2/Q3 and before the email gate.
 */
import type { QuizBuildUp, QuizLoading, QuizScreen } from './types';

/** Match the USCN interstitial pacing so both quizzes feel identical. */
export const DMM_TRANSITION_DURATION_MS = 2500;

export const DMM_TRANSITION_AFTER_Q2: QuizScreen = {
  id: 'transition_after_q2',
  type: 'screen',
  order: 2.5,
  title: 'Nice. Now for the fun part.',
  description: 'Keep going. Your full reading and personalized regimen are waiting at the end.',
  countsTowardProgress: false,
};

/**
 * UX-6: the staged reveal build-up replaces the old 10-second loading screen.
 * Copy and seed-stage visuals live in uxCopy.ts / DrManiRevealBuildUp.
 */
export const DMM_BUILDUP_BEFORE_EMAIL: QuizBuildUp = {
  id: 'buildup_before_email',
  type: 'buildup',
  order: 9.5,
  countsTowardProgress: false,
};

/** Map question id -> interstitial(s) to insert immediately after that question. */
export const DMM_INTERSTITIALS_AFTER: Record<string, Array<QuizScreen | QuizLoading | QuizBuildUp>> = {
  q2_grows: [DMM_TRANSITION_AFTER_Q2],
  q9_proudest: [DMM_BUILDUP_BEFORE_EMAIL],
};
